import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IHistoryListState } from 'entities/History/History.models';
import { historyListReducers } from 'entities/History/History.reducers';
import { historyListEffects } from 'entities/History/History.effects';

export const historyList = createModel<IRootModel>()({
  state: {
    data: [],
    loading: false,
  } as IHistoryListState,
  reducers: historyListReducers,
  effects: historyListEffects,
});
